import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Container, NbCard } from "@/components/nb";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const processed = useRef(false);
  const { setUserFromReset } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = loc.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      toast.error("Missing Google session. Try again.");
      nav("/auth", { replace: true });
      return;
    }
    const sid = decodeURIComponent(m[1]);
    api.post("/auth/google/session", { session_id: sid })
      .then((r) => {
        localStorage.setItem("sl_token", r.data.token);
        if (setUserFromReset) setUserFromReset(r.data.user);
        // clear the fragment
        try { window.history.replaceState({}, "", "/"); } catch { /* ignore */ }
        toast.success(`Welcome, ${r.data.user.name.split(" ")[0]}!`);
        nav("/", { replace: true });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        nav("/auth", { replace: true });
      });
    // eslint-disable-next-line
  }, []);

  return (
    <Container className="max-w-md">
      <NbCard className="p-8 text-center" data-testid="auth-callback">
        <div className="font-heading font-black text-2xl tracking-tighter">Signing you in...</div>
        <p className="mt-2 text-neutral-700">One sec, we're finishing up with Google.</p>
      </NbCard>
    </Container>
  );
}
